export class CamposPadroes {
    static toObjeto(cdUsuarioInc: number, cdUsuarioAlt: number, dtInclusao: string, dtAlteracao: string, dmSituacao: boolean): {
        cdUsuarioInc: number;
        cdUsuarioAlt: number;
        dtInclusao: string;
        dtAlteracao: string;
        dmSituacao: boolean;
    } {
        return {
            cdUsuarioInc: cdUsuarioInc,
            cdUsuarioAlt: cdUsuarioAlt,
            dtInclusao: dtInclusao,
            dtAlteracao: dtAlteracao,
            dmSituacao: dmSituacao,
        };
    }
}
